(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fiaco-product-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const palette = event.target.closest('.fiaco-card-swatches');
    if (!palette) return;
    event.preventDefault();
    event.stopPropagation();
    const button = event.target.closest('[data-fiaco-card-color]');
    if (!button) return;
    const card = button.closest('.card-wrapper');
    if (!card) return;
    const image = card.querySelector('.card__media .media img');
    const status = palette.parentElement.querySelector('.fiaco-card-swatch-status');
    const selection = button.dataset.variantId;
    card.dataset.fiacoSelectedVariant = selection;
    palette.querySelectorAll('[data-fiaco-card-color]').forEach((swatch) => {
      const selected = swatch === button;
      swatch.classList.toggle('fiaco-card-swatch--selected', selected);
      swatch.setAttribute('aria-pressed', String(selected));
    });
    card.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin && url.pathname.includes('/products/') && selection) {
        url.searchParams.set('variant', selection);
        link.href = url.pathname + url.search + url.hash;
      }
    });
    card.querySelectorAll('modal-opener [data-product-url]').forEach((opener) => {
      if (button.dataset.variantUrl) opener.dataset.productUrl = button.dataset.variantUrl;
    });
    if (status) status.textContent = '';
    if (!image || !button.dataset.image) {
      if (status) status.textContent = button.dataset.unavailable;
      return;
    }
    const preview = new Image();
    preview.onload = () => {
      if (card.dataset.fiacoSelectedVariant !== selection) return;
      image.removeAttribute('srcset');
      image.src = button.dataset.image;
      image.alt = button.dataset.imageAlt;
      card.dataset.fiacoColorPreview = button.dataset.color;
    };
    preview.onerror = () => {
      if (card.dataset.fiacoSelectedVariant === selection && status) {
        status.textContent = button.dataset.unavailable;
      }
    };
    preview.src = button.dataset.image;
  }, true);
  } catch(e) { console.error(e); }
})();

})();
